import type { Role } from "@event-planner/shared";

/**
 * Roles available in admin filter dropdowns. Mirrors the role hierarchy
 * (ADR-001) in display order. Used by both the Users and Attendees pages
 * via the shared `TwoStageFilter` component.
 */
export const FILTER_ROLES: Role[] = [
  "admin",
  "organizer",
  "internal",
  "invitee",
  "companion",
];

/**
 * Capitalize the first character. Used for rendering role labels.
 */
export function titleCase(value: string): string {
  if (!value) return value;
  return value.charAt(0).toUpperCase() + value.slice(1);
}
